import { createRoot } from "react-dom/client";
import { HelmetProvider } from "react-helmet-async";
// Self-hosted fonts (bundled with the app, no blocking Google Fonts request)
import "@fontsource/space-grotesk/latin-500.css";
import "@fontsource/space-grotesk/latin-600.css";
import "@fontsource/inter/latin-400.css";
import "@fontsource/inter/latin-500.css";
import App from "./App.tsx";
import "./index.css";

const root = document.getElementById("root");
if (root) {
  // react-snap serialises the live DOM, which lacks React's Suspense/text markers,
  // so hydrateRoot always fails (React errors #418/#423) and re-renders anyway.
  // Render fresh instead: the prerendered HTML stays visible until React's first
  // commit replaces it with identical markup — no console errors, no wasted hydration.
  (window as any).__ENVIR_PRERENDERED__ = root.hasChildNodes();
  createRoot(root).render(
    <HelmetProvider>
      <App />
    </HelmetProvider>
  );
}
